/**
 * The rate text for the Order Details header. A split parent is a flat $0.00 for every viewer; other orders keep
 * their existing text (OMS revenue, or the shipper or carrier pricing for non-OMS orders).
 *
 * @param {{ oms?: boolean, order_status?: string, order_revenue?: number|null, shipper_id?: string, carrier_id?: string }} order
 * @param {{ userId?: string, shipperPricing?: string, carrierPricing?: string }} viewer - the viewer's user id and the
 *   precomputed pricing text for each non-OMS path
 * @returns {string} the rate text, or '' when there is nothing to show
 */
export const orderRateText = (order, { userId, shipperPricing, carrierPricing } = {}) => {
    if (!order) return '';
    if (order.order_status === 'split') return '$0.00';
    if (order.oms) {
        return order.order_revenue ? `$${order.order_revenue.toFixed(2)}` : '-';
    } else if (userId === order.shipper_id) {
        return shipperPricing;
    } else if (userId === order.carrier_id) {
        return carrierPricing;
    }
    return '';
};
